<template>
    <div class="row">
        <div class="column">
            <form class="form verticalpadding">
                <div class="row">
                    <div class="column medium-8 text-right float-right">
                        <b-button type="is-dark" outlined v-if="type == 'customer' || type == 'escalation'" @click.prevent="$emit('toggleRelated')" :disabled="loadingComment">
                            {{ viewRelatedButton ? 'Verberg gerelateerde logs' : 'Alle gerelateerde logs' }}
                        </b-button>

                        <b-button @click="toggleCommentField" type="is-dark" v-if="canAddComment">
                            {{ showCommentField ? 'Verberg' : 'Opmerking toevoegen' }}
                        </b-button>

                        <CustomerMail
                            v-if="type !== 'escalation' && !user.deurwaarder"
                            :customer="customer"
                            :invoice="invoice"
                            :contract="contract"
                            @mailSent="loadCorrespondingLogs()"
                        />
                    </div>
                    <div class="column medium-4">
                        <h3>{{ title }}</h3>
                    </div>
                </div>

                <b-notification
                    type="is-warning"
                    v-if="showDeurwaarderAlert"
                    aria-close-label="Close notification"
                    role="alert">
                    Als deurwaarder kunt u alleen opmerkingen plaatsen bij dossiers en facturen.
                </b-notification>

                <transition name="slide">
                    <div class="row" v-show="showCommentField">
                        <div class="column">
                            <b-field :label="editingLog ? 'Opmerking aanpassen' : 'Opmerking plaatsen'">
                                <b-input type="textarea" :disabled="loadingComment" v-model="myComment"></b-input>
                            </b-field>

                            <div class="text-right">
                                <b-button type="is-light" @click="toggleCommentField" :disabled="loadingComment">Annuleren</b-button>
                                <b-button type="is-success" @click="addComment" :disabled="myComment.length === 0 || loadingComment" :loading="loadingComment">
                                    {{ editingLog ? 'Aanpassen' : 'Toevoegen' }}
                                </b-button>
                            </div>

                            <hr>
                        </div>
                    </div>
                </transition>

                <div id="invoice-logs" v-if="logs && logs.length">
                    <InvoiceLog
                        v-for="(log, index) in logs"
                        :log="log"
                        :propsType="type"
                        :key="`${type}log_${index}`"
                        @setLoading="setLoading"
                        @edit-log="editLog"
                        @delete-log="deleteLog"
                    />
                </div>
                <div v-else-if="!!loading">
                    <div v-for="i in 3" :key="i" class="marginbottom15">
                        <b-skeleton height="30px" width="150px" :animated="true"></b-skeleton>
                        <b-skeleton height="60px" :animated="true"></b-skeleton>
                    </div>
                </div>
                <div v-else-if="!loading">
                    <p>Er zijn (nog) geen {{ title === 'Opmerkingen' ? 'opmerkingen' : 'logs' }}.</p>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import toastMixin from '@/mixins/toastMixins.js'
import InvoiceLog from '@/vue/invoices/components/InvoiceLog'
import CustomerMail from '@/vue/customers/components/CustomerMail'

export default {
    name: 'CommunicationLogs',

    mixins: [toastMixin],

    props: {
        title: {
            type: String,
            default: 'Communicatielog'
        },
        type: {
            type: String,
            default: 'invoice'
        },
        logs: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        viewRelatedButton: {
            type: Boolean,
            default: false
        },
        customer: {
            type: [Object, null],
            required: false,
            default: null
        },
        invoice: {
            type: [Number, String],
            required: false,
            default: null
        },
        contract: {
            type: [Number, String],
            required: false,
            default: null
        }
    },

    components: {
        InvoiceLog,
        CustomerMail
    },

    data () {
        return {
            showCommentField: false,
            loadingComment: false,
            myComment: '',
            editingLog: null
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        canAddComment() {
            if (!this.user.deurwaarder) {
                return true;
            }
            return ['invoice', 'escalation'].includes(this.type);
        },

        showDeurwaarderAlert() {
            return this.user.deurwaarder && ['customer', 'contract'].includes(this.type);
        }
    },

    methods: {
        toggleCommentField() {
            this.editingLog = null

            if (this.user.deurwaarder && !['invoice', 'escalation'].includes(this.type)) {
                return;
            }

            this.showCommentField = !this.showCommentField

            if(!this.showCommentField){
                this.myComment = ''
            }
        },

        addComment(){
            this.loadingComment = true
            let url = false
            let method = 'post'

            switch(this.type){
                case 'invoice':
                    url = '/api/invoices/'+this.$route.params.id+'/comment'
                    break
                case 'customer':
                    url = '/api/customer/'+this.$route.params.id+'/comment'
                    break
                case 'contract':
                    url = '/api/contract/'+this.$route.params.id+'/comment'
                    break
                case 'escalation':
                    url = '/api/escalations/'+this.$route.params.id+'/comment'
                    break
                default:
                    url = false
            }

            if (!url) {
                console.error('Invalid type')
                return
            }

            if (this.editingLog) {
                method = 'put'
                url += '/' + this.editingLog.id
            }

            axios[method](url, {message: this.myComment}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(response => {
                if(response.data == 'success'){
                    this.showMessage('Opmerking ' + (this.editingLog ? 'bijgewerkt' : 'geplaatst') + '!')

                    this.showCommentField = false
                    this.myComment = ''
                    this.editingLog = null

                    this.loadCorrespondingLogs()
                } else {
                    throw new Error()
                }
            }).catch((e) => {
                if (e.response.data == 'access-denied') {
                    this.showError('Je hebt niet voldoende rechten om deze opmerking te bewerken.')
                } else {
                    this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                }
            }).then(() => {
                this.loadingComment = false
            })
        },

        loadCorrespondingLogs(){
            if (this.type === 'invoice'){
                this.$emit('loadInvoice')
            } else if(this.type == 'contract') {
                this.$emit('startUp')
            } else if(this.type == 'customer') {
                this.$emit('loadCustomerLogs')
            } else if(this.type == 'escalation') {
                this.$emit('loadEscalationLogs')
            }
        },

        editLog(log){
            this.editingLog = log
            this.myComment = log.longtext
            this.showCommentField = true
        },

        deleteLog(log) {
            this.$buefy.dialog.confirm({
                title: 'Opmerking verwijderen',
                message: 'Weet je zeker dat je deze opmerking wilt verwijderen?',
                confirmText: 'Verwijderen',
                cancelText: 'Annuleren',
                type: 'is-danger',
                onConfirm: () => {
                    let url = false
                    switch(this.type){
                        case 'invoice':
                            url = '/api/invoices/'+this.$route.params.id+'/comment/'+log.id
                            break
                        case 'customer':
                            url = '/api/customer/'+this.$route.params.id+'/comment/'+log.id
                            break
                        case 'contract':
                            url = '/api/contract/'+this.$route.params.id+'/comment/'+log.id
                            break
                        default:
                            url = false
                    }

                    if (!url) {
                        console.error('Invalid type')
                        return
                    }

                    axios.delete(url, {
                        headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                    }).then(response => {
                        if(response.data == 'success'){
                            this.showMessage('Opmerking verwijderd!')

                            if (this.type === 'invoice'){
                                this.$emit('loadInvoice')
                            } else if(this.type == 'contract') {
                                this.$emit('startUp')
                            } else if(this.type == 'customer') {
                                this.$emit('loadCustomerLogs')
                            }
                        } else {
                            throw new Error()
                        }
                    }).catch((e) => {
                        if (e.response.data == 'access-denied') {
                            this.showError('Je hebt niet voldoende rechten om deze opmerking te verwijderen.')
                        } else {
                            this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                        }
                    })
                }
            })
        },

        setLoading(loading){
            this.loadingComment = loading
        }
    }
}
</script>

<style scoped>
.notification {
    margin-bottom: 1rem;
}
</style>